module.exports = __webpack_public_path__ + "static/media/19_B.b1a6a7cd.png";